import { validateCPF } from './cpfValidator';

export const validateCNPJ = (cnpj) => {
  if (!cnpj) return false;
  const clean = cnpj.replace(/[^\d]/g, '');
  if (clean.length !== 14) return false;
  if (/^(\d)\1{13}$/.test(clean)) return false;
  let sum = 0, pos = 5;
  for (let i = 0; i < 12; i++) {
    sum += parseInt(clean[i]) * pos;
    pos = pos === 2 ? 9 : pos - 1;
  }
  let d = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (parseInt(clean[12]) !== d) return false;
  sum = 0; pos = 6;
  for (let i = 0; i < 13; i++) {
    sum += parseInt(clean[i]) * pos;
    pos = pos === 2 ? 9 : pos - 1;
  }
  d = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  return parseInt(clean[13]) === d;
};

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const TIPOS_PIX = [
  { value: '', label: 'Selecione o tipo' },
  { value: 'CPF', label: 'CPF' },
  { value: 'CNPJ', label: 'CNPJ' },
  { value: 'Email', label: 'E-mail' },
  { value: 'Celular', label: 'Celular' },
  { value: 'ChaveAleatoria', label: 'Chave Aleatória' }
];

export const validatePixKey = (tipo, valor) => {
  const v = (valor || '').trim();
  if (!v) return { valid: true, message: '' };
  if (!tipo) return { valid: false, message: 'Selecione o tipo da chave PIX' };
  switch (tipo) {
    case 'CPF':
      return validateCPF(v) ? { valid: true } : { valid: false, message: 'CPF inválido' };
    case 'CNPJ':
      return validateCNPJ(v) ? { valid: true } : { valid: false, message: 'CNPJ inválido' };
    case 'Email':
      return EMAIL_REGEX.test(v) ? { valid: true } : { valid: false, message: 'E-mail inválido' };
    case 'Celular': {
      const cleanValue = v.replace(/\D/g, '');
      return cleanValue.length === 11 ? { valid: true } : { valid: false, message: 'Celular inválido (deve ter 11 dígitos)' };
    }
    case 'ChaveAleatoria':
      return UUID_REGEX.test(v) ? { valid: true } : { valid: false, message: 'Chave aleatória deve ser no formato UUID' };
    default:
      return { valid: true };
  }
};
